<template functional>
  <SocialImage
    title="Instagram"
    :class="[data.class, data.staticClass]"
    channel="instagram"
    v-bind="data.attrs"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'InstagramImage',
  components: {
    SocialImage,
  },
};
</script>
